<template>
  <div class="item-base">
    <div class="item">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserDetailBase"
  }
</script>

<style lang="less" scoped>
.item-base{
  margin-top: 20px;
  height: 75vh;
  overflow: auto;
  padding: 10px;
  .item{
    width: 75%;
  }
}
</style>